export default "__VITE_ASSET__yF$qpnhvM_lmu5QZvvbijw__";